import { SET_COMMODITY_ROWS, ADD_COMMODITY_ROW, UPDATE_COMMODITY_ROWS } from './types';

export const setCommodityRows = (rows) => ({
  type: SET_COMMODITY_ROWS,
  payload: rows,
});

export const addCommodityRow = (newCommodityRow) => ({
  type: ADD_COMMODITY_ROW,
  payload: newCommodityRow,
});

export const updateCommodityRows = (updatedCommodityRows) => ({
  type: UPDATE_COMMODITY_ROWS,
  payload: updatedCommodityRows,
});
